import { render, staticRenderFns } from "./summary-section.vue?vue&type=template&id=32a6a0f3&scoped=true"
import script from "./summary-section.vue?vue&type=script&setup=true&lang=js"
export * from "./summary-section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./summary-section.vue?vue&type=style&index=0&id=32a6a0f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a6a0f3",
  null
  
)

export default component.exports